module.exports = __webpack_public_path__ + "img/knife-kitchen.db8dc1ac.svg";